const initListedServices = (block) => {
	if (!block || block.dataset.fcListedServicesInit) {
		return;
	}

	const stickyMedia = block.querySelector('.fc-listed-services__sticky-media');
	const stickyImage = block.querySelector('.fc-listed-services__sticky-image');
	const items = Array.from(
		block.querySelectorAll('.wp-block-fc-block-fc-listed-services-inner')
	);

	if (!stickyMedia || !stickyImage || items.length === 0) {
		return;
	}

	block.dataset.fcListedServicesInit = '1';
	const FADE_DURATION_MS = 220;
	let currentImageUrl = '';
	let currentImageAlt = '';
	let currentImageWidth = 0;
	let currentImageHeight = 0;
	let isTransitioning = false;
	let pendingImage = null;
	let transitionTimeout = 0;
	let settleTimeout = 0;
	let overlayImage = null;

	const setImageDimensions = (image, width, height) => {
		if (width > 0 && height > 0) {
			image.width = width;
			image.height = height;
		} else {
			image.removeAttribute('width');
			image.removeAttribute('height');
		}
	};

	const getOverlayImage = (width, height) => {
		if (!overlayImage) {
			overlayImage = document.createElement('img');
			overlayImage.className = 'fc-listed-services__sticky-image fc-listed-services__sticky-image--overlay';
			overlayImage.alt = '';
			stickyMedia.appendChild(overlayImage);
		}
		setImageDimensions(overlayImage, width, height);
		return overlayImage;
	};

	const applyImageState = (url, alt, width, height, clearOverlay = false) => {
		currentImageUrl = url;
		currentImageAlt = alt;
		currentImageWidth = width;
		currentImageHeight = height;

		if (!url) {
			block.classList.remove('has-sticky-image');
			stickyImage.removeAttribute('src');
			stickyImage.removeAttribute('srcset');
			stickyImage.removeAttribute('sizes');
			stickyImage.alt = '';
			if (clearOverlay && overlayImage) {
				overlayImage.style.opacity = '0';
				overlayImage.removeAttribute('src');
				overlayImage.alt = '';
			}
			return;
		}

		// The base image is rendered responsively with the first item's srcset.
		// Once JavaScript swaps the image, that srcset would otherwise override
		// the new src and make the browser display the first image again.
		stickyImage.removeAttribute('srcset');
		stickyImage.removeAttribute('sizes');
		stickyImage.setAttribute('src', url);
		stickyImage.alt = alt;
		setImageDimensions(stickyImage, width, height);
		block.classList.add('has-sticky-image');
		if (clearOverlay && overlayImage) {
			overlayImage.style.opacity = '0';
			overlayImage.removeAttribute('src');
			overlayImage.alt = '';
		}
	};

	const fadeToImage = (url, alt, width, height) => {
		if (url === currentImageUrl && alt === currentImageAlt && width === currentImageWidth && height === currentImageHeight) {
			return;
		}

		if (!url) {
			if (!currentImageUrl) {
				applyImageState('', '', 0, 0, true);
			}
			return;
		}

		if (isTransitioning) {
			pendingImage = { url, alt, width, height };
			return;
		}

		if (!currentImageUrl) {
			applyImageState(url, alt, width, height, true);
			return;
		}

		window.clearTimeout(transitionTimeout);
		window.clearTimeout(settleTimeout);

		isTransitioning = true;
		const nextOverlayImage = getOverlayImage(width, height);
		nextOverlayImage.setAttribute('src', url);
		nextOverlayImage.alt = alt;
		nextOverlayImage.style.opacity = '0';
		block.classList.add('has-sticky-image');

		window.requestAnimationFrame(() => {
			window.requestAnimationFrame(() => {
				nextOverlayImage.style.opacity = '1';
			});
		});

		transitionTimeout = window.setTimeout(() => {
			applyImageState(url, alt, width, height, false);

			// Keep the overlay covering the base image for one paint after the
			// source swap. Clearing it immediately can expose an unpainted frame.
			window.requestAnimationFrame(() => {
				nextOverlayImage.style.opacity = '0';

				settleTimeout = window.setTimeout(() => {
					nextOverlayImage.removeAttribute('src');
					nextOverlayImage.alt = '';
					isTransitioning = false;
					if (pendingImage) {
						const next = pendingImage;
						pendingImage = null;
						fadeToImage(next.url, next.alt, next.width, next.height);
					}
				}, FADE_DURATION_MS);
			});
		}, FADE_DURATION_MS);
	};

	const setStickyImage = (item) => {
		if (!item) {
			return;
		}

		const nextUrl = item.dataset.fcListedImageUrl || '';
		const nextAlt = item.dataset.fcListedImageAlt || '';
		const nextWidth = Number.parseInt(item.dataset.fcListedImageWidth || '0', 10);
		const nextHeight = Number.parseInt(item.dataset.fcListedImageHeight || '0', 10);

		items.forEach((candidate) => {
			candidate.classList.toggle('is-active', candidate === item);
		});

		fadeToImage(nextUrl, nextAlt, nextWidth, nextHeight);
	};

	const pickInitialItem = () => {
		const withImage = items.find((item) => (item.dataset.fcListedImageUrl || '').trim() !== '');
		return withImage || items[0] || null;
	};

	const findActiveItem = () => {
		const viewportCenter = window.innerHeight * 0.5;
		let nearest = null;
		let nearestDistance = Number.POSITIVE_INFINITY;

		items.forEach((item) => {
			const rect = item.getBoundingClientRect();
			const itemCenter = rect.top + rect.height * 0.5;
			const distance = Math.abs(itemCenter - viewportCenter);

			if (distance < nearestDistance) {
				nearestDistance = distance;
				nearest = item;
			}
		});

		return nearest;
	};

	let rafId = 0;
	const onScroll = () => {
		if (rafId) {
			return;
		}

		rafId = window.requestAnimationFrame(() => {
			rafId = 0;
			setStickyImage(findActiveItem());
		});
	};

	setStickyImage(pickInitialItem());
	onScroll();

	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onScroll);
};

const initAll = () => {
	// Guard against running frontend scroll animation calculations and window listeners inside the CMS block editor
	if (
		(document.body && document.body.classList.contains('wp-admin')) ||
		typeof window.wp?.blockEditor !== 'undefined' ||
		document.querySelector('.editor-styles-wrapper')
	) {
		return;
	}
	document
		.querySelectorAll('.wp-block-fc-block-fc-listed-services')
		.forEach((block) => initListedServices(block));
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initAll);
} else {
	initAll();
}
